import React from "react";
import { motion } from "framer-motion";
import TrustedBy from "../components/TrustedBy";
import TestimonialCarousel from "../components/TestimonialCarousel";
import FAQ from "../components/FAQ";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";
import StructuredData, {
  createBreadcrumbSchema,
} from "../components/StructuredData";
import { seoData } from "../utils/seo";

const Contact = () => {
  const testimonials = [
    {
      type: "case-study",
      image: "/home/customer-stories/mutualista-azuay.jpg",
      stats: [
        {
          title: "Saved 20 hours/week",
          subtitle: "on project tracking and reporting",
        },
        {
          title: "Increased 80%",
          subtitle: "in data accessibility among stakeholders",
        },
      ],
      link: "https://youtube.com/watch?v=LJFRSxzPnTc",
      linkText: "Watch Story",
    },
    {
      type: "testimonial",
      logo: "/clients/client-3.svg",
      text: "It's an all-in-one, online management tool that makes project management easy. I can follow up the economy, time, quality, tasks, risks, etc. of all of my projects. I can do all of this online, which makes me very mobile. It lets me set up my workflows and projects as I please, and keep all my files on the platform as well. Estabild doesn't just make remote work possible, it makes it as effortless as sitting in the office.",
      author: "Sven-Åke Yashar Khezri Kraim",
      position: "Project Manager at NREP",
      avatar: "/home/testimonials/6552731dfe00305f497ce941_sven-ake nrep.jpg",
    },
    {
      type: "testimonial",
      logo: "/home/company-logos/6552731dfe00305f497ce93d_cipte logo dark.png",
      text: "Estabild is helping our company to organize and streamline critical project information among key stakeholders. Now, our teammates can easily collaborate and share status updates. Estabild gives upper management a clear overview that enables us to make better decisions about our portfolio performance.",
      author: "Jaime Macias",
      position: "Head of Project Management at Ciport & Tecnac",
      avatar: "/home/testimonials/6552731dfe00305f497ce932_jaime macias.jpg",
    },
  ];

  const contactSeo = seoData.contact;
  const structuredData = [
    createBreadcrumbSchema([
      { name: "Home", url: "/" },
      { name: "Contact", url: contactSeo.url },
    ]),
  ];

  return (
    <div className="min-h-screen pt-28 sm:pt-32 lg:pt-40 pb-8 sm:pb-12">
      <SEO
        title={contactSeo.title}
        description={contactSeo.description}
        keywords={contactSeo.keywords}
        url={contactSeo.url}
      />
      <StructuredData data={structuredData} />
      <div className="container-custom mb-8 sm:mb-12 text-center px-4">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
          Book Demo
        </h1>
      </div>

      <div className="w-full bg-primary-600 py-8 sm:py-12 lg:py-20">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            {/* Left Column: Carousel */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="relative h-full"
            >
              <TestimonialCarousel testimonials={testimonials} />
            </motion.div>

            {/* Right Column: Form */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <ContactForm description="Schedule a 30-min call with us and learn what we can offer to your business." />
            </motion.div>
          </div>
        </div>
      </div>

      <TrustedBy />

      <FAQ />
    </div>
  );
};

export default Contact;
